<div class="sidebar_layout" [ngClass]="{ 'collapsed': (sidebarService.collapsed$ | async) }">
  <quote-hub-header />
  <quote-hub-sidebar />
  <main class="content">
    <router-outlet />
  </main>
</div>